<script setup lang="ts">
import BCard from 'src/shared/components/base/BCard/BCard.vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import {
  mdiShareVariant,
  mdiContentCopy,
  mdiCheck,
  mdiInformationBox,
} from '@quasar/extras/mdi-v7';
// import { ComputedRef } from 'vue';

interface Props {
  childLoginToken: string | undefined;
  copied: boolean;
}

const props = defineProps<Props>();

const qrCode = props.childLoginToken
  ? useQRCode(props.childLoginToken, {
      margin: 0,
      color: {
        // dark: '#ffc900',
        dark: '#000000',
        light: '#b89ec6',
      },
    })
  : null;

const emit = defineEmits<{
  copy: [code: string];
  share: [code: string];
}>();
</script>

<template>
  <BCard size="xs">
    <q-card-section v-if="childLoginToken">
      <q-img
        v-if="qrCode"
        :src="qrCode"
      />
    </q-card-section>
    <q-card-section v-else>
      <div class="text-h6">
        {{ $t('CHILD_LOGIN_TOKEN_NOT_FOUND') }}
      </div>
    </q-card-section>
    <q-separator class="q-my-sm" />
    <q-card-section>
      <p class="text-caption opacity-70">
        <q-icon
          :name="mdiInformationBox"
          size="sm"
        />
        {{ $t('CHILD_LOGIN_TOKEN_INSTRUCTIONS') }}
      </p>
    </q-card-section>
    <q-card-actions align="right">
      <q-chip
        v-if="copied"
        :icon="mdiCheck"
        dense
        color="accent"
        :label="$t('CODE_COPIED')"
      />
      <q-btn
        :icon="mdiContentCopy"
        :title="$t('COPY_CODE')"
        flat
        round
        :color="$q.dark.isActive ? 'white' : 'dark'"
        dense
        @click="childLoginToken && emit('copy', childLoginToken)"
      />
      <q-btn
        :icon="mdiShareVariant"
        :title="$t('SHARE_CODE')"
        flat
        round
        :color="$q.dark.isActive ? 'white' : 'dark'"
        dense
        @click="childLoginToken && emit('share', childLoginToken)"
      />
    </q-card-actions>
  </BCard>
</template>
